import React from 'react';
import DefaultConfiguration from '../../elements/configViews/DefaultConfiguration';
import DateUtils from '../../../lib/DateUtils';
import { isNil, get } from 'lodash';

class CredentialOverviewTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerDataFetch: true,
      prevId: !isNil(props.data) && !isNil(props.data.id) ? props.data.id : null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.id !== state.prevId) {
      return {
        triggerDataFetch: true,
        prevId: props.data.id,
      };
    }
    return null;
  }

  componentDidMount() {
    if (!this.props.disableInitialFetch) {
      this._loadCredData();
    }
    if (this.props.data.sdk_application_id && !this.props.sdkAppUuid) {
      this.props.fetchSdkApplication(this.props.data.sdk_application_id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.triggerDataFetch === true) {
      this._loadCredData();
    }
    if (
      this.props.data.sdk_application_id &&
      !this.props.sdkAppUuid &&
      this.props.data.sdk_application_id !== prevProps.data.sdk_application_id
    ) {
      this.props.fetchSdkApplication(this.props.data.sdk_application_id);
    }
  }

  render() {
    const { data, connectionFields } = this.props;
    const createdDate = DateUtils.convertDateStringToFormat(data.created_at);
    const lastUpdate = DateUtils.convertDateStringToFormat(data.updated_at);
    const credentialConfig = get(this.props, 'data.template_config', {});

    return (
      <div className="tab-content data-map-overview-tab">
        <section>
          <div className="detail-row">
            <div className="detail-col">
              <div className="detail-key">Credential ID</div>
              <div className="detail-value">{data.id}</div>
            </div>
          </div>
          {data.auth_template?.id ? (
            <div className="detail-row">
              <div className="detail-col">
                <div className="detail-key">Auth Template</div>
                <div className="detail-value">
                  {data.auth_template.display_name || `Template ID: ${data.auth_template.id}`}
                </div>
              </div>
            </div>
          ) : null}
          <DefaultConfiguration
            config={{
              ...data.credentials_non_secure_data,
              ...credentialConfig,
            }}
            configFields={connectionFields}
          />
          <div className="detail-row">
            <div className="detail-col">
              <div className="detail-key">Created On</div>
              <div className="detail-value">{createdDate}</div>
            </div>
            <div className="detail-col">
              <div className="detail-key">Last Updated On</div>
              <div className="detail-value">{lastUpdate}</div>
            </div>
          </div>
          {this.props.sdkAppName || this.props.sdkAppUuid || data.created_by_external_id ? (
            <>
              {this.props.sdkAppName || this.props.sdkAppUuid ? (
                <div className="detail-row">
                  {this.props.sdkAppName ? (
                    <div className="detail-col">
                      <div className="detail-key">SDK: Application Name</div>
                      <div className="detail-value">{this.props.sdkAppName}</div>
                    </div>
                  ) : null}
                  {this.props.sdkAppUuid ? (
                    <div className="detail-col">
                      <div className="detail-key">SDK: Application ID</div>
                      <div className="detail-value">{this.props.sdkAppUuid}</div>
                    </div>
                  ) : null}
                </div>
              ) : null}
              {data.created_by_external_id ? (
                <div className="detail-row">
                  <div className="detail-col">
                    <div className="detail-key">SDK: External Reference ID</div>
                    <div className="detail-value">{data.created_by_external_id}</div>
                  </div>
                </div>
              ) : null}
            </>
          ) : null}
        </section>
      </div>
    );
  }

  _loadCredData() {
    if (this.state.triggerDataFetch === true) {
      this.setState({
        triggerDataFetch: false,
      });
    }

    this.props.getDataCredential(this.props.data.id);
  }
}

export default CredentialOverviewTab;
